export default "__VITE_ASSET__BBLEXZAo__"